// extracted by mini-css-extract-plugin
export var container = "_oq-0";
export var dotAnimation = "_oq-2";
export var dotsLoading = "_oq-1";